import { Link } from "react-router-dom";

export const PrivacyNote = () => (
  <p className="text-sm text-[#626B79]" data-testid="privacy-note">
    Usaremos estos datos para enviarte tu ejercicio y ayudarte a continuar. Puedes pedir su
    eliminación.{" "}
    <Link to="/privacidad" className="underline hover:text-[#275FBE]">
      Más sobre privacidad
    </Link>
    .
  </p>
);
